module.exports = __webpack_public_path__ + "img/20191228125953360截图20191228104148254.23c02a12.jpg";